import Main from './Main'
import Lista from './components/Lista'
import Detalhes from './components/Detalhes'

export default [
  {
    path: 'trabalhe-conosco',
    name: 'trabalhe.conosco.main',
    redirect: { name: 'trabalhe.conosco.index' },
    component: Main,
    children: [
      {
        path: 'lista',
        name: 'trabalhe.conosco.index',
        component: Lista
      },
      {
        path: 'detalhes',
        name: 'trabalhe.conosco.detalhes',
        component: Detalhes
      }
    ]
  }
]



// WEBPACK FOOTER //
// ./src/app/website/trabalhe-conosco/routes.js